import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import ProgressViewerFragment, {
  ProgressViewerFragmentConfigProps,
} from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ProgressViewerFragment/ProgressViewerFragment";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";

const configProps: ProgressViewerFragmentConfigProps = {
  title: "Progress",
  total: "details.progress.total",
  current: "details.progress.current",
};

function ProgressViewerFragmentDemo() {
  const [total, setTotal] = useState(10);
  const [current, setCurrent] = useState(4);

  const commonProps = {
    task: { details: { progress: { total, current } } },
    onTaskChange: () => undefined,
    blockInput: false,
    showValidation: false,
    taskType: {} as ViewerFragmentCommonProps["taskType"],
  } as ViewerFragmentCommonProps;

  return (
    <Demo>
      <Name>ProgressViewerFragment</Name>
      <Highlight>
        <ProgressViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="current"
          type="number"
          id="progressviewerfragmentdemo-current"
          value={String(current)}
          onChange={(e) => setCurrent(Number(e.target.value))}
        />
        <FixaInputField
          label="total"
          type="number"
          id="progressviewerfragmentdemo-total"
          value={String(total)}
          onChange={(e) => setTotal(Number(e.target.value))}
        />
      </Actions>
    </Demo>
  );
}

export default memo(ProgressViewerFragmentDemo);
